<div
  [ngStyle]="{ background: dev ? '#AEAEAE' : bg, color: dev ? '#FFFFF' : color }"
  [ngClass]="{ disabled: dev }"
  class="block"
>
  <div
    matRipple
    [matRippleCentered]="false"
    [matRippleUnbounded]="true"
    [matRippleDisabled]="dev"
    class="w-100 h-100 overflow-hidden d-flex justify-content-center align-items-center"
    (click)="click($event)"
  >
    <span class="title">{{ title }}</span>
  </div>
  @if (active) {
    <span class="chip activated">{{ 'connected' | translate }}</span>
  } @else {
    @if (!!count) {
      <span class="count">{{ count }}</span>
    } @else {
      @if (new) {
        <span class="chip new">{{ 'new' | translate }}!</span>
      } @else {
        @if (dev) {
          <span class="chip dev">{{ 'in_development' | translate }}!</span>
        } @else {
          @if (beta) {
            <span class="chip beta">{{ 'test_mode' | translate }}</span>
          }
        }
      }
    }
  }
</div>
